module.exports = __webpack_public_path__ + "img/refund_details.ba9c7d48.svg";